import React from "react";
import { motion } from "framer-motion";
import { WinnerCard } from "./WinnerCard";

const ACCENT = {
  sky: { text: "text-sky-500", line: "from-sky-500", dot: "bg-sky-500" },
  violet: { text: "text-violet-300", line: "from-violet-500", dot: "bg-violet-500" },
};

export function TrackPodium({ track, infos }) {
  const a = ACCENT[track.accent];
  const [first, second, third] = track.winners;
  return (
    <section className="relative mx-auto w-full max-w-6xl px-4 py-14 md:py-20" data-testid={`track-${track.key}`}>
      <motion.div initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
        className="mb-8 md:mb-12">
        <p className={`flex items-center gap-2 font-mono text-[12px] font-bold uppercase tracking-[0.3em] ${a.text}`}>
          <span className={`h-2 w-2 rounded-full ${a.dot} animate-pulse`} /> {track.kicker}
        </p>
        <h2 className="mt-2 font-display text-[44px] font-extrabold uppercase leading-[0.9] text-white sm:text-[64px] lg:text-[80px]">
          {track.title} <span className={a.text}>winners</span>
        </h2>
        <div className={`mt-4 h-px w-40 bg-gradient-to-r ${a.line} to-transparent`} />
      </motion.div>

      <div className="grid gap-5 md:grid-cols-3 md:items-end md:gap-6">
        <div className="md:order-2"><WinnerCard w={first} info={infos[first.slug]} featured index={0} /></div>
        <div className="md:order-1 md:pb-10"><WinnerCard w={second} info={infos[second.slug]} index={1} /></div>
        <div className="md:order-3 md:pb-16"><WinnerCard w={third} info={infos[third.slug]} index={2} /></div>
      </div>
    </section>
  );
}
